// import i18next from "i18next";
// import { initReactI18next } from "react-i18next";
// import en from "./locales/en.json";
// import ar from "./locales/ar.json";
// const lang = localStorage.getItem("language");

// i18next.init({
//   interpolation: { escapeValue: false },
//   lng: lang ? lang : "en",
//   fallbackLng: lang ? lang : "en",
//   resources: {
//     en: {
//       translation: en,
//     },
//     ar: {
//       translation: ar,
//     },
//   },
// });

// export default i18next;


// Dynamic language Change using i18next (Json file call from backend)

import i18next from "i18next";
import HttpBackend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

const language = localStorage.getItem("language");

let lang = language ? language : "en";

i18next
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    interpolation: { escapeValue: false },
    lng: lang ? lang : "en",
    fallbackLng: lang ? lang : "en",
    backend: {
      loadPath: `${process.env.REACT_APP_LANGUAGE_URL}${lang}/file.json`,

    },
  });

export default i18next;